import { useContext } from "react"; // Importing the 'useContext' hook from react

// Importing our custom context that will hold our experiment data
import { VarifyContext } from "./VarifyContext";

/**
 * Custom React Hook to manage experiments and variations
 */
export const useVariant = ({experimentId, variationId}: {experimentId: string; variationId?: number}) => { // Defining the hook function with parameters experimentId and variationId 
    // Get the experiments store from our custom context
    const {experimentsStore} = useContext(VarifyContext); 
    // If an experiment exists in our context for this particular 'experimentId', we will get it. Otherwise a default object is assigned which is not valid for any experiment.
    const experiment = experimentsStore[experimentId] || {
      id: null, // This will hold the id of the experiment 
      isVariation: false, // This indicates if an experiment variation has been selected or not
      variationId: null, // This is the id of the specific variation within this experiment.
    };
    // If a 'variationId' is provided then we check if it matches with currently active variation in our experiments store 
    if(variationId) {
        experiment.isVariation = experiment.isVariation && (variationId === experiment.variationId); // It will reassign the value of 'isVariation' based on a condition
    }
    // The function returns an object that holds information about current experiment and variation 
    return experiment;
};
export default useVariant;  // Exporting this hook to be used in other components.
